module.exports = __webpack_public_path__ + "media/reskin-images/icon--chevron-down-74b362a3.svg";